import { useEffect, useState } from 'react';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Footer';
import PeacockIntro from '../intro/PeacockIntro';
import HeroBanner from './landing/HeroBanner';
import SubCategoryCarousel from './landing/SubCategoryCarousel';
import LabelCards from './landing/LabelCards';
import DealsHot from './landing/DealsHot';
import Testimonials from './landing/Testimonials';
import ContactSection from './landing/ContactSection';

const INTRO_KEY = 'nv_intro_seen';

export default function HomePage() {
  const [showIntro, setShowIntro] = useState(() => !sessionStorage.getItem(INTRO_KEY));

  useEffect(() => {
    document.title = 'NAYAVARNAM — Luxury Fashion';
  }, []);

  const finishIntro = () => {
    sessionStorage.setItem(INTRO_KEY, '1');
    setShowIntro(false);
  };

  return (
    <div className="page-shell">
      {showIntro && <PeacockIntro onComplete={finishIntro} />}
      <Navbar overHero />
      <div className="hero-stage">
        <HeroBanner />
      </div>
      <main>
        <SubCategoryCarousel />
        <LabelCards />
        <DealsHot />
        <Testimonials />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
